import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { ProposalProps } from 'types/props-obj/ProposalProps';
const initialState: ProposalProps = {
    apiEndPoint: "proposal",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
  };
const proposal = createSlice({
    name: 'proposal',
    initialState,
    reducers: {
      
       
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all proposal list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
  
      // get proposal details
      setProposal(state, action) {
        state.item = action.payload;
      },
  
      // GET Proposals
      setProposalsSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD Proposal
    addProposalSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT Proposal
    editProposalSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
    },

    deleteProposalSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    },
    deleteAttachmentSuccess(state, action) {
      if(state?.item){
        const deleteData = state?.item?.attachments?.filter((item) => item.id !== action.payload);
        state.item.attachments = deleteData;
      }
    },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertToggle;
    }
    }
  });
  export default proposal.reducer;
  export const {    getList,setPageNumber,setPageLimit,alertPopupToggle} = proposal.actions;

  export function getProposals(params:any={}) {
    return async () => {
      try {
        const response = await axios.get(initialState.apiEndPoint,{params:params});
        dispatch(proposal.actions.setProposalsSuccess(response.data));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }

  export function getProposal(id: number | undefined) {
    return async () => {
      try {
        const response = await axios.get([initialState.apiEndPoint,  id].join('/'));
        dispatch(proposal.actions.setProposal(response.data));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }

  export function addProposal(ls:any) {
    return async () => {
      try {        
        const response = await axios.post(initialState.apiEndPoint, ls,{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(proposal.actions.addProposalSuccess(response.data));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }
  
  export function editProposal(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.post(initialState.apiEndPoint, {id:id,...ls},{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(proposal.actions.editProposalSuccess(response.data));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }

  export function deleteProposal(id: number | undefined) {
    return async () => {
      try {
        await axios.delete([initialState.apiEndPoint,  id].join('/'));
        dispatch(proposal.actions.deleteProposalSuccess(id));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }
  export function deleteAttachement(id: number | undefined) {
    return async () => {
      try {
        await axios.delete('/attachment/'+id);
        dispatch(proposal.actions.deleteAttachmentSuccess(id));
      } catch (error) {
        dispatch(proposal.actions.hasError(error));
      }
    };
  }